export default __webpack_public_path__ + "static/media/naturalResp.68bc5a27.jpg";